/**
* [Flags]
*/
export var LogSeverity;
(function (LogSeverity) {
    LogSeverity[LogSeverity["None"] = 0] = "None";
    LogSeverity[LogSeverity["Debug"] = 1] = "Debug";
    LogSeverity[LogSeverity["Info"] = 2] = "Info";
    LogSeverity[LogSeverity["Verbose"] = 3] = "Verbose";
    LogSeverity[LogSeverity["Warn"] = 4] = "Warn";
    LogSeverity[LogSeverity["Error"] = 8] = "Error";
    LogSeverity[LogSeverity["Fatal"] = 16] = "Fatal";
    LogSeverity[LogSeverity["All"] = 31] = "All";
})(LogSeverity || (LogSeverity = {}));
;
